// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IVolume from "./IVolume";

export default interface IAnchorData extends IVolume {
  name: string;
}
